<template>
  <div class="article__header">
    <div class="article__bar" v-if="showMore.title && !disableBar">
      <div class="bar">
        <app-link class="bar__content" 
          :to="showMore.url" 
          :path-type="showMore.type" 
          :routing-data="showMore.routing_data">
          <p class="bar__label bar__label--urgent">{{ item.title }}</p>
          <p class="bar__title bar__title--urgent"> {{ showMore.title }} </p>
        </app-link>
      </div>
    </div>
    <h1 class="article__header--title">{{ title }}</h1>
    <div class="article__subheader">
      <div class="article__date" v-if="articleDate">
        <template v-if="authorInfo">
          <app-link :to="authorInfo.url" :path-type="authorInfo.type" class="article__author">
            <photo-loader
              v-if="authorInfo?.image"
              :image="authorInfo?.image"
              :imgWidth="authorInfo?.image?.width"
              :imgHeight="authorInfo?.image?.height"
            />
            <div class="article__author-text">
              <span class="article__author-name name">{{ authorInfo?.title }}</span>
              <time class="article__author-date date" datetime="">
                <i class="news__icon icon-clock-ico"></i>
                {{ formatDate(publicationStartDate) }},
                {{ formatDateToTime(publicationStartDate) }} / aktualizacja:
                {{ formatDateToTime(modifyDate) }}
              </time>
            </div>
          </app-link>
        </template>

        <template v-else-if="signature">
          <span class="name">{{ signature }}</span>
          <time class="date" datetime="">
            <i class="news__icon icon-clock-ico"></i>
            {{ formatDate(publicationStartDate) }}, {{ formatDateToTime(publicationStartDate) }} /
            aktualizacja:
            {{ formatDateToTime(modifyDate) }}
          </time>
        </template>
      </div>
      <div class="article__social">
        <span class="article__share">Udostępnij:</span>

        <a href="#" class="article__icon article__icon-facebook" @click="facebookShare()">
          <i class="icon-facebook"></i>
        </a>
        <a href="#" class="article__icon article__icon-twitter" @click="twitterShare()">
          <i class="social-icon icon-twitter-new black"></i>
        </a>
        <a
          :href="`mailto:?subject=${title}&body=${shareUrl}`"
          class="article__icon article__icon-mail"
        >
          <i class="icon-mail-alt"></i>
        </a>
        <a
          v-if="isGoogleShare"
          href="#"
          class="article__icon article__icon-share"
          @click="copyLink()"
        >
          <i class="icon-share-blue"></i>
        </a>
      </div>
    </div>
    <div class="article__separator"></div>
  </div>
</template>

<script setup>
import {onMounted, computed} from 'vue'
import { useUtils } from '@/composables/useUtils'
import AppLink from '@/components/layout/AppLink.vue'
import PhotoLoader from '@/components/elements/PhotoLoader.vue'
import {useSectionsStore} from '@/stores/section'
import {storeToRefs} from 'pinia'

const sectionsStore = useSectionsStore()
const { fetchUrgentBeam } = sectionsStore
const { urgentItem } = storeToRefs(sectionsStore)

const item = computed(() => urgentItem.value)
const showMore = computed(() => urgentItem.value?.show_more ?? false)

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  releaseDate: {
    type: Number,
    default: 0
  },
  publicationStartDate: {
    type: Number,
    default: 0
  },
  modifyDate: {
    type: Number,
    default: 0
  },
  shareUrl: {
    type: String,
    default: ''
  },
  articleDate: {
    type: Boolean,
    default: true
  },
  isGoogleShare: {
    type: Boolean,
    default: true
  },
  signature: {
    type: String,
    default: ''
  },
  authorInfo: {
    type: Object,
    default: () => ({})
  },
  disableBar: {
    type: Boolean,
    default: false
  }
})

const { formatDate, formatDateToTime } = useUtils()

const facebookShare = () => {
  const url = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`
  const options =
    'toolbar=no, scrollbars=yes, resizable=yes, top=500, left=500, width=600, height=500'
  window.open(url, '_blank', options)
}

const twitterShare = () => {
  const url = `https://twitter.com/share?url=${window.location.href}&text=${props.title}&hashtags=wieszwiecej`
  const options =
    'toolbar=no, scrollbars=yes, resizable=yes, top=500, left=500, width=600, height=500'
  window.open(url, '_blank', options)
}

const copyLink = () => {
  var dummy = document.createElement('input'),
   text = window.location.href;
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);
}

onMounted(() => {
  fetchUrgentBeam()
})

</script>

<style lang="scss">
@import '@/assets/scss/components/article/article-header.scss';
@import "@/assets/scss/components/modules/module-bar.scss";
</style>
